import { townLabel } from '../town.ts';

/**
 * A property's address in the shape every address view uses: the street in
 * large type, and beneath it, smaller, the town (with the neighbourhood and who
 * said so, 091), the state and the ZIP.
 */
export function PropertyAddress({
  street, city, state, zip, neighbourhood, neighbourhoodSource,
}: {
  street: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  neighbourhood: string | null;
  neighbourhoodSource: 'lookup' | 'person' | null;
}) {
  const town = townLabel(city, neighbourhood, neighbourhoodSource);
  const rest = [town, [state, zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  return (
    <span className="block">
      <span className="block text-base font-medium text-neutral-900">{street ?? 'No street recorded'}</span>
      {rest && <span className="block text-sm text-neutral-600">{rest}</span>}
    </span>
  );
}
